import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { IApplicationStatusesResponse, ICityRequest, ICreateProfileDictionaryRequest } from "./types";
import { Dictionaries, DictionaryType } from "@/model/dictionaries";

export const getGuides = (list: DictionaryType[]): AxiosPromise<Dictionaries> => {
  const resultParams = list.reduce((accumulator, currentValue) => {
    return accumulator + "," + currentValue;
  }, "");
  return axiosInstance.get(`/dictionaries?items=${resultParams}`);
};

export const getApplicationStatuses = (vacancyId: number): AxiosPromise<IApplicationStatusesResponse[]> => {
  return axiosInstance.get("/dictionary/va-statuses?vacancy_id=" + vacancyId);
};

export const getCities = (request: ICityRequest): AxiosPromise<any> => {
  return axiosInstance.post("/dictionary/cities", request);
};

export const createProfileDictionary = (request: ICreateProfileDictionaryRequest): AxiosPromise<any> => {
  return axiosInstance.post("/dictionary/profile", request);
};
